import { PlatformType } from '@invideoio/web-shared/constants/common';

export type SizeMap = {
  [key in PlatformType | 'default']: { height?: number; width?: number };
};

export const getImageSize = (platform: PlatformType, sizeMap: SizeMap) => {
  return sizeMap[platform] || sizeMap['default'];
};
